import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

interface MountOptions {
  hydrate: boolean;
  onRecoverableError: (error: Error) => void;
}

export function mountReactApp(container: Element, application: React.ReactElement, options: MountOptions): void {
  if (options.hydrate) {
    hydrateRoot(container, application, {
      onRecoverableError: (error) => options.onRecoverableError(error as Error),
    });
    return;
  }
  createRoot(container).render(application);
}
